import React from 'react';
import ExitIcon from '@moda/icons/exit-16';
import classNames from 'classnames';
import { Clickable } from '@moda/om';
import { noop } from '@moda/portal-stanchions';
import { useAuthMethod } from '../../hooks/useAuth';
import { PasswordAuthentication } from './PasswordAuthentication';
import { PasswordlessAuthentication } from './PasswordlessAuthentication';
import { SignInFormValues } from './PasswordSignIn';
import { RegisterFormValues } from './Register';

import './Authentication.scss';

export type DefaultValues = Partial<SignInFormValues> | Partial<RegisterFormValues>;

export type AuthenticationProps = {
  fullPage?: boolean;
  modal?: boolean;
  defaultValues?: DefaultValues;
  onAuth?: () => void;
  showAuthModal?: () => void;
  hideAuthModal?: () => void;
};

export const Authentication: React.FC<AuthenticationProps> = ({
  fullPage = false,
  modal = false,
  defaultValues,
  onAuth = noop,
  showAuthModal,
  hideAuthModal
}) => {
  const authMethod = useAuthMethod({ authLocation: 'standard_login' });

  return (
    <div
      className={classNames('Authentication', {
        'Authentication--fullPage': fullPage,
        'Authentication--modal': modal
      })}
      data-testid="authentication"
    >
      {modal && hideAuthModal ? (
        <Clickable aria-label="Close" className="Authentication__close" onClick={hideAuthModal}>
          <ExitIcon />
        </Clickable>
      ) : null}
      {authMethod === 'passwordless' ? (
        <PasswordlessAuthentication
          defaultValues={defaultValues}
          fullPage={fullPage}
          hideAuthModal={hideAuthModal}
          modal={modal}
          onAuth={onAuth}
          showAuthModal={showAuthModal}
        />
      ) : (
        <PasswordAuthentication
          defaultValues={defaultValues}
          fullPage={fullPage}
          hideAuthModal={hideAuthModal}
          onAuth={onAuth}
          showAuthModal={showAuthModal}
        />
      )}
    </div>
  );
};
